const BUTTON_SIZE_PX = 50;
const BUTTON_MOBILE_SIZE_PX = 44;
const buttonWrapperCls = "_yr2b1ity5zo";
const guideBubbleCls = "_yr2g1om9xu9";
const outlineCls = "_yr2o1cc9q28";
const buttonCls = "_yr2bwbgk63";

export { BUTTON_MOBILE_SIZE_PX, BUTTON_SIZE_PX, buttonCls, buttonWrapperCls, guideBubbleCls, outlineCls };
import "./floating-button.style.linaria.module.css";
//# sourceMappingURL=floating-button.style.js.map
